/* eslint-disable jsx-a11y/anchor-is-valid */
import { useLongPress, useScroll, useSize } from 'ahooks';
import { Divider, Image, Toast } from 'antd-mobile';
import img from 'app/img';
import axios from 'axios';
import React, { ReactElement, useCallback, useEffect, useRef, useState } from 'react';
import { AiOutlineArrowLeft, AiOutlineBug, AiOutlineShareAlt } from 'react-icons/ai';
import { useLocation } from 'react-router-dom';
import { PagePostDT, PostsDataType } from 'services/apis/cnt2/post-api';
import { ResourceDto } from 'services/gather_bo/10_exhentai';
import { bizBaseUrl } from 'services/request';
import { useWindowSize } from 'usehooks-ts';

const ReaderManga = () => {
  const state = useLocation().state;
  const chapterList = state?.chapterList as ResourceDto[];
  const chapterInex = state?.chapterInex as number;
  const postTitle = state?.postTitle as string;
  const imageInex = state?.imageInex as number;
  const height = window.innerHeight;

  const clickCount = useRef(0); // 用于点击监控的计数

  const [showOptionPanel, toggleShowOptionShowPanel] = useState(true); // 是否显示操作面板

  const tipPanelRef = useRef<HTMLDivElement>(null);
  const [showTipPanle, toggleShowTipPanel] = useState(false); // 是否显示提示面板

  const [showImgIndex, toggleShowImgIndex] = useState(true); // 是否显示图片序号

  const sliderRef = useRef(null);
  const observerRef = useRef(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isInitialLoad, setIsInitialLoad] = useState(true); // 标志位

  // 点击监听
  useLongPress(
    () => {
      // 长按开始
      // console.log("long press");
    },
    tipPanelRef,
    {
      delay: 500,
      // moveThreshold: {},
      onClick: () => {
        clickCount.current += 1;
        setTimeout(() => {
          if (clickCount.current === 1) {
            // 单击
            toggleShowOptionShowPanel(!showOptionPanel);
            // console.log("single click: ", clickCount);
          } else if (clickCount.current === 2) {
            // 双击
            // console.log("setTimeout onDoubleClick: ", clickCount);
          }
          clickCount.current = 0;
        }, 300);
      },
      onLongPressEnd: () => {
        // 长按结束
        // console.log("long press end");
      },
    }
  );

  let scrollTop = 0;
  let topValue = 0;
  // 滑动监听
  const getScollTop = () => {
    let scrollTop = 0;
    if (document?.documentElement && document?.documentElement?.scrollTop) {
      scrollTop = document?.documentElement.scrollTop;
    } else if (document?.body) {
      scrollTop = document?.body.scrollTop;
    }
    return scrollTop;
  };

  const bindHandleScroll = () => {
    scrollTop = getScollTop();
    if (scrollTop <= topValue) {
      // console.log("上划", showOptionPanel);
      toggleShowOptionShowPanel(true);
    } else {
      // console.log("下划", showOptionPanel);
      setTimeout(() => {
        toggleShowOptionShowPanel(false);
      }, 500);
    }
    setTimeout(function () {
      topValue = scrollTop;
    }, 500);
  };

  useEffect(() => {
    window.addEventListener('scroll', bindHandleScroll);
    return () => {
      window.removeEventListener('scroll', bindHandleScroll);
    };
  }, []);

  // 滑动修改页面索引
  // const handleIntersect = useCallback(
  //   (entries) => {
  //     if (isInitialLoad) {
  //       setIsInitialLoad(false); // 初始化完成后关闭标志位
  //       return;
  //     }

  //     entries.forEach((entry) => {
  //       if (entry.isIntersecting) {
  //         const observedIndex = parseInt(entry.target.dataset.index, 10);
  //         // 仅当当前图片索引更接近顶部时才更新 currentIndex
  //         if (observedIndex !== currentIndex) {
  //           console.log(`${currentIndex} 已进入`);
  //           setCurrentIndex(observedIndex);
  //         }
  //       }
  //     });
  //   },
  //   [currentIndex, isInitialLoad]
  // );
  // useEffect(() => {
  //   const slider = sliderRef.current;

  //   const observer = new IntersectionObserver(handleIntersect, {
  //     root: slider,
  //     threshold: 0.7, // 当图片至少70%出现在视口时触发
  //   });

  //   observerRef.current = observer;

  //   slider?.childNodes.forEach((img, index) => {
  //     observer.observe(img);
  //     img.dataset.index = index; // 用于记录图片索引
  //     console.log(index + "已观察");
  //   });

  //   return () => {
  //     observer.disconnect();
  //   };
  // }, [handleIntersect]);

  // 跳转页面
  useEffect(() => {
    scrollToAnchor(imageInex);
  }, [imageInex]);

  // 跳转锚点
  const scrollToAnchor = (anchorIndex: number) => {
    // Toast.show(anchorIndex + "");
    if (anchorIndex != null && anchorIndex !== undefined) {
      setCurrentIndex(anchorIndex);
      const anchorName = '#' + anchorIndex;
      // 找到锚点
      let anchorElement = document.getElementById(anchorName);
      // 如果对应id的锚点存在，就跳转到锚点
      if (anchorElement) {
        anchorElement.scrollIntoView({ block: 'start', behavior: 'smooth' });
      }
    }
  };
  // 上一张
  const scrollToPrev = () => {
    const index = Math.max(currentIndex - 1, 0);
    scrollToAnchor(index);
  };
  // 下一张
  const scrollToNext = () => {
    const index = Math.min(currentIndex + 1, chapterList.length - 1);
    scrollToAnchor(index);
  };

  // 页面内容
  return (
    <center>
      {/* <div className=" p-2 m-2 bg-slate-200 rounded-md shadow-md fixed top-0 left-0">
        {"当前位置: " + (currentIndex + 1) + " / " + chapterList.length}
      </div> */}
      <div
        ref={sliderRef}
        className=" bg-slate-100"
      >
        {chapterList
          // .sort((item) => item.resourceNo)
          .map((item, index) => (
            <div className=" relative">
              <div
                key={index}
                id={'#' + index}
                className=" gap-3 mb-2 border border-slate-600"
              >
                <Image
                  src={(item.optImgUrl || item.resourceRealityUrl)
                    ?.replaceAll('\\', '/')
                    .replaceAll('D:/_Resource/', bizBaseUrl + '/images/')}
                  lazy={true}
                  placeholder={
                    <img
                      src={img.loadingImg}
                      width={Math.floor(window.innerWidth / 2.3)}
                      height={Math.floor(window.innerWidth / 1.5)}
                      className=" object-cover"
                    />
                  }
                  fallback={
                    <img
                      src={img.loadingImg}
                      width={Math.floor(window.innerWidth / 2.3)}
                      height={Math.floor(window.innerWidth / 1.5)}
                      className=" object-cover"
                    />
                  }
                  width={'100%'}
                  // height={"600px"}
                />
              </div>
              <div className=" text-[10px] border-0 absolute -bottom-3 w-full"> {showImgIndex && index + 1}</div>
            </div>
          ))}
      </div>
      {/* 触摸面板 */}
      <div className=" fixed top-0 left-0 w-full h-full flex flex-col">
        <div
          className={[' flex justify-center items-center basis-1/4', showTipPanle && 'bg-red-400 bg-opacity-50 '].join(
            ' '
          )}
          onClick={(e) => {
            scrollToPrev();
          }}
        >
          {showTipPanle && '上一页'}
        </div>
        <div
          className={[
            ' flex justify-center items-center basis-1/2',
            showTipPanle && 'bg-green-400 bg-opacity-50 ',
          ].join(' ')}
        >
          <div className=" flex w-full h-full">
            <div
              className={[
                ' flex justify-center items-center basis-1/5',
                showTipPanle && 'bg-green-100 bg-opacity-50 ',
              ].join(' ')}
              onClick={(e) => {
                scrollToPrev();
              }}
            >
              {showTipPanle && '上一页'}
            </div>
            <div
              ref={tipPanelRef}
              className={[
                ' flex justify-center items-center basis-3/5',
                showTipPanle && 'bg-green-400 bg-opacity-50 ',
              ].join(' ')}
            >
              {showTipPanle && '菜单'}
            </div>
            <div
              className={[
                ' flex justify-center items-center basis-1/5',
                showTipPanle && 'bg-green-700 bg-opacity-50 ',
              ].join(' ')}
              onClick={(e) => {
                scrollToNext();
              }}
            >
              {showTipPanle && '下一页'}
            </div>
          </div>
        </div>
        <div
          className={[' flex justify-center items-center basis-1/4', showTipPanle && 'bg-blue-400 bg-opacity-50 '].join(
            ' '
          )}
          onClick={(e) => {
            scrollToNext();
          }}
        >
          {showTipPanle && '下一页'}
        </div>
      </div>
      {/* 控制面板 */}
      {showOptionPanel && (
        <>
          <div>
            <div className=" fixed top-0 w-full ">
              <div className={[' flex justify-between items-center gap-5 p-3 bg-black bg-opacity-30'].join(' ')}>
                <AiOutlineArrowLeft
                  size={22}
                  color="white"
                  className=" min-w-6"
                  onClick={() => {
                    window.history.go(-1);
                  }}
                />
                <div className="-ml-8 grow text-center text-sm text-white font-bold text-nowrap">{postTitle}</div>
                {/* <AiOutlineShareAlt size={22} color="white" />
                <AiOutlineBug size={22} color="white" /> */}
              </div>
            </div>
            <div className=" fixed w-full bottom-0 ">
              <div className=" bg-black text-white flex justify-center gap-5 text-base p-3 shadow-md border border-slate-800 bg-opacity-70">
                <div>目录</div>
                <div>上一话</div>
                <div>下一话</div>
                <div>目录</div>
              </div>
              {/* <div className=" text-center p-3 text-sm text-white bg-slate-500 font-bold border-b-2 text-nowrap">
                {postTitle}
              </div> */}
              {/* <div className=" text-base text-white font-bold flex justify-around items-center bg-gray-500">
                <div
                  className=" p-5 bg-gray-400 basis-1/3 border-r-2"
                  onClick={() => {
                    Toast.show("上一话");
                  }}
                >
                  上一话
                </div>
                <div
                  className=" p-5 bg-gray-400 basis-1/3 border-r-2"
                  onClick={() => {
                    Toast.show("目录");
                  }}
                >
                  目录
                </div>
                <div
                  className=" p-5 bg-gray-400 basis-1/3 border-r-2"
                  onClick={() => {
                    toggleShowTipPanel(!showTipPanle);
                  }}
                >
                  提示
                </div>
                <div
                  className=" p-5 bg-gray-400 basis-1/3"
                  onClick={() => {
                    Toast.show("下一话");
                  }}
                >
                  下一话
                </div>
              </div> */}
            </div>
          </div>
        </>
      )}
    </center>
  );
};

export default ReaderManga;
